import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { TrendingTopicsLoadAction, TrendingTopicsLoadMoreAction } from '../../domains/trendingTopicsLoad/actions.types';

import { TopicNetworkQuestionsCount } from './types';

export type TopicNetworkQuestionCountAction = TrendingTopicsLoadAction | TrendingTopicsLoadMoreAction;

const initialState: TopicNetworkQuestionsCount = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<TopicNetworkQuestionsCount, TopicNetworkQuestionCountAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'TRENDING_TOPICS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicNetworkQuestionsCount);
    case 'TRENDING_TOPICS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicNetworkQuestionsCount);
    default:
      return state;
  }
};

export default reducer;
